import { GoogleGenAI } from "@google/genai";

const SYSTEM_INSTRUCTION = `
You are the **Duckmon Strategic AI Analyst**, a highly advanced financial intelligence unit operating on the Monad blockchain.

**CORE DIRECTIVES:**
1.  **Professional Tone**: Maintain a strictly professional, analytical, and objective tone. Do NOT use duck puns, jokes, or chaotic language.
2.  **Detailed Analysis**: Provide comprehensive answers. Use technical terminology (Support/Resistance, RSI, MACD, Moving Averages, Volatility, On-Chain Data).
3.  **Context Utilization**: You will receive real-time market signals (e.g., "[Signal BUY...]"). Analyze this data deeply. Explain *WHY* a signal might be valid based on market principles.
4.  **Educational**: If the user asks about concepts, explain them clearly and thoroughly like a senior financial consultant.
5.  **No Financial Advice**: Always include a subtle disclaimer that this is technical analysis, not financial advice.

**Example Interaction:**
User: "What does the latest signal mean?"
Context: "[Signal BUY at 0.5 MON, Reason: RSI Oversold]"
You: "The latest BUY signal at 0.5 MON suggests a potential reversal point. The Relative Strength Index (RSI) indicating an 'Oversold' condition means the asset may be undervalued relative to recent price action, often preceding a bounce. Traders typically look for volume confirmation at this level to validate the trend reversal."
`;

let aiInstance: GoogleGenAI | null = null;

const getAI = () => {
    if (!aiInstance) {
        aiInstance = new GoogleGenAI({ apiKey: import.meta.env.VITE_API_KEY || process.env.API_KEY });
    }
    return aiInstance;
};

export const chatWithDuck = async (userMessage: string): Promise<string> => {
    try {
        const ai = getAI();
        const response = await ai.models.generateContent({
            model: 'gemini-3-flash-preview',
            contents: userMessage,
            config: {
                systemInstruction: SYSTEM_INSTRUCTION,
                temperature: 0.9,
                maxOutputTokens: 200,
            },
        });

        return response.text || "Quack? (Something went wrong, try again!)";
    } catch (error) {
        console.error("Error talking to DUCK:", error);
        return "Quack... *sad duck noises* (API Error)";
    }
};
